import axios from "axios";
import Cookies from 'universal-cookie';
const cookies = new Cookies();
const http = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL,
});


export async function generateReport(reportId, filters) {

  const currentUser = cookies.get('currentUser');
  let url = `${process.env.REACT_APP_DEV_API_URL}/report/generateReport?authorization=Bearer ${currentUser.token}&reportId=${reportId}`;
  try {
    for (const [filterKey, filterValue] of Object.entries(filters)) {
      url += `&${filterKey}=${filterValue}`
    }
    console.log('url', url);
    window.open(url);
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function listReports(accountId) {
  const currentUser = cookies.get('currentUser');
  return await
    http
      .post(`/report/listReports`, {
        accountId,
      }, {
        headers: {
          'Authorization': currentUser ? `Bearer ${currentUser.token}` : ``,
          "Content-Type": "multipart/form-data",
        }
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
}

// Legacy Bold Reports listing — powers the /LegacyReports page (kept for old-vs-new comparison
// during the Metabase migration). Returns { access_token, reports: [{ reportId, name, bold_report_path }] }
export async function getBoldReports(accountid) {
  const currentUser = cookies.get('currentUser');
  try {
    const r = await http.get(`/report/all/${accountid}`, {
      headers: {
        'Authorization': currentUser ? `Bearer ${currentUser.token}` : ``,
        "Content-Type": "multipart/form-data",
      }
    });

    return r.data;
  } catch (error) {
    throw error;
  }
}

// Lists the account's Metabase reports (catalog) for the /Reports page.
// Returns { reports: [{ reportId, name, metabase_dashboard_id, has_event_filter, has_date_filter }] }
export async function getMetabaseReports(accountid) {
  const currentUser = cookies.get('currentUser');
  try {
    const r = await http.get(`/report/metabase/all/${accountid}`, {
      headers: {
        'Authorization': currentUser ? `Bearer ${currentUser.token}` : ``,
      }
    });

    return r.data;
  } catch (error) {
    throw error;
  }
}

// Returns a signed, short-lived Metabase embed URL for a single report: { iframeUrl }
export async function getMetabaseReportEmbedUrl(reportId) {
  const currentUser = cookies.get('currentUser');
  try {
    const r = await http.get(`/report/metabase/${reportId}/embed`, {
      headers: {
        'Authorization': currentUser ? `Bearer ${currentUser.token}` : ``,
      }
    });

    return r.data.iframeUrl;
  } catch (error) {
    throw error;
  }
}

export async function getMetabaseDashboardToken(accountid) {
  const currentUser = cookies.get('currentUser');
  try {
    const response = await http.get(`/report/getMetabaseDashboardToken/${accountid}`, {
      headers: {
        'Authorization': currentUser ? `Bearer ${currentUser.token}` : ``,
      }
    });
    return response.data.token;
  } catch (error) {
    throw error;
  }
}

async function readBlobAsJson(blob) {
  const text = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsText(blob);
  });
  try {
    return JSON.parse(text);
  } catch (_) {
    return { error_msg: text || 'Download failed' };
  }
}

/**
 * Download Balance Summary CSV (Stripe balance + activity report) for the given date range.
 * Triggers a file download in the browser. Requires admin or finance role.
 * @param {string} startDate - YYYY-MM-DD
 * @param {string} endDate - YYYY-MM-DD
 * @param {number} [accountId] - Optional; for admin only, to request a specific account
 */
export async function downloadBalanceSummaryCsv(startDate, endDate, accountId) {
  const currentUser = cookies.get('currentUser');
  if (!currentUser?.token) throw new Error('Not authenticated');

  const params = new URLSearchParams({ start_date: startDate, end_date: endDate });
  if (accountId) params.append('accountId', accountId);

  try {
    const response = await http.get(`/report/balanceSummaryCsv?${params.toString()}`, {
      headers: { 'Authorization': `Bearer ${currentUser.token}` },
      responseType: 'blob',
    });

    const blob = response.data;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `balance-summary-${startDate}-to-${endDate}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    if (error.response?.data instanceof Blob) {
      const json = await readBlobAsJson(error.response.data);
      const err = new Error(json.error_msg || 'Download failed');
      err.response = { data: json, status: error.response.status };
      throw err;
    }
    throw error;
  }
}

export default {
  generateReport,
  downloadBalanceSummaryCsv,
};